import React from 'react';
import { Button, ButtonGroup, Card, CircularProgress, Grid } from '@material-ui/core';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import './wipStyles.scss';
import { ColorsDash } from '../color';

const COLORS = [
    '#0074D9',
    '#FF4136',
    '#2ECC40',
    '#FF851B',
    '#7FDBFF',
    '#B10DC9',
    '#FFDC00',
    '#001f3f',
    '#39CCCC',
    '#01FF70',
    '#85144b',
    '#F012BE',
    '#3D9970',
    '#111111',
    '#AAAAAA'
];

export const WipScreenLoader = () => {
    return (
        <div className="wip-dash-loader">
            <span>
                <div>Please Wait while Fetching Data..</div>
                <CircularProgress />
            </span>
        </div>
    );
};

export const WipNoRecord = () => {
    return (
        <div className="wip-dash-loader">
            <div className="no-record">No Record Found</div>
        </div>
    );
};

export const WipDashboardBranch = ({ state = {}, array = {}, handlePieCard, handleChangeAssignedUser, onChartClickHandler, redirectToAssignedJobs }) => {
    const colors = ColorsDash && ColorsDash.length > 0 ? ColorsDash : COLORS;

    return (
        <>
            {state.showHeaderLoader ? (
                <div className="wip-dash-Card">
                    <WipScreenLoader />
                </div>
            ) : (
                <Card className="wip-dash-Card" style={{ position: 'relative' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8, width: '100%' }}>
                        <div className="dash-segmented-group">
                            <button
                                type="button"
                                className={`dash-segmented-btn ${array.selectedPieChartType === 'A' ? 'active' : ''}`}
                                onClick={() => handlePieCard && handlePieCard('A')}
                            >
                                Assigned Jobs
                            </button>
                            <button
                                type="button"
                                className={`dash-segmented-btn ${array.selectedPieChartType === 'B' ? 'active' : ''}`}
                                onClick={() => handlePieCard && handlePieCard('B')}
                            >
                                By Branch
                            </button>
                        </div>

                        {array.selectedPieChartType === 'A' ? (
                            <select onChange={handleChangeAssignedUser} className="selectclass" value={array.byAssignedUser || 'Default'}>
                                <option value={'Default'}>All Users</option>
                                {state.assignedUserList?.map((btn) => {
                                    return (
                                        <option key={btn.userID} value={btn.userID}>
                                            {btn.userName}{' '}
                                        </option>
                                    );
                                })}
                            </select>
                        ) : null}
                    </div>

                    <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12}>
                            {array.selectedPieChartType === 'B' ? (
                                !state.chartdata || state.chartdata.length === 0 ? (
                                    <WipNoRecord />
                                ) : (
                                    <>
                                        <div className="pieChartSize">
                                            <ResponsiveContainer>
                                                <PieChart>
                                                    <Pie
                                                        data={state.chartdata}
                                                        cx={70}
                                                        cy={45}
                                                        paddingAngle={3}
                                                        outerRadius={45}
                                                        innerRadius={25}
                                                        fill="#8884d8"
                                                        dataKey="value"
                                                    >
                                                        {state.chartdata.map((entry, index) => (
                                                            <Cell
                                                                key={entry.name || index}
                                                                fill={colors[index % colors.length]}
                                                                // style={{ cursor: 'pointer' }}
                                                                // onClick={() => onChartClickHandler && onChartClickHandler({ workflowID: 'All', bn: entry.name }, true)}
                                                            />
                                                        ))}
                                                    </Pie>
                                                </PieChart>
                                            </ResponsiveContainer>
                                        </div>
                                        <div className="pie-branch-list custom-scroll">
                                            {state?.chartdata?.map((m, i) => {
                                                let color = colors[i % colors.length];
                                                return (
                                                    <div style={{ padding: 0 }} key={m.name || i}>
                                                        <div className="branch-List-box">
                                                            <div
                                                                style={{
                                                                    background: color,
                                                                    height: 8,
                                                                    width: 8,
                                                                    borderRadius: '50%',
                                                                    flexShrink: 0
                                                                }}
                                                            ></div>
                                                            <div style={{ fontWeight: 700, color: '#0f172a' }}>{m.value}</div>
                                                            <div style={{ color: '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.name}</div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </>
                                )
                            ) : !array.assignedJobs || array.assignedJobs.length === 0 ? (
                                <WipNoRecord />
                            ) : (
                                <>
                                    <div className="pieChartSize">
                                        <ResponsiveContainer>
                                            <PieChart>
                                                <text
                                                    x={75}
                                                    y={50}
                                                    textAnchor="middle"
                                                    dominantBaseline="middle"
                                                    fontWeight="bold"
                                                    onClick={() => redirectToAssignedJobs && redirectToAssignedJobs(null, true)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {array.assignedJobsTotals}
                                                </text>
                                                <Pie
                                                    data={array.assignedJobs}
                                                    cx={70}
                                                    cy={45}
                                                    paddingAngle={3}
                                                    outerRadius={45}
                                                    innerRadius={25}
                                                    fill="#8884d8"
                                                    dataKey="total"
                                                >
                                                    {array.assignedJobs.map((entry, index) => (
                                                        <Cell
                                                            key={`cell-${index}`}
                                                            fill={colors[index % colors.length]}
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => redirectToAssignedJobs && redirectToAssignedJobs(entry, false)}
                                                        />
                                                    ))}
                                                </Pie>
                                            </PieChart>
                                        </ResponsiveContainer>
                                    </div>
                                    <div className="pie-job-list custom-scroll">
                                        {array.assignedJobs.map((m, i) => {
                                            let color = colors[i % colors.length];
                                            return (
                                                <div
                                                    style={{ padding: 0, cursor: 'pointer' }}
                                                    key={m.workflow || i}
                                                    onClick={() => redirectToAssignedJobs && redirectToAssignedJobs(m, false)}
                                                >
                                                    <div className="branch-List-box">
                                                        <div
                                                            style={{
                                                                background: color,
                                                                height: 8,
                                                                width: 8,
                                                                borderRadius: '50%',
                                                                flexShrink: 0
                                                            }}
                                                        ></div>
                                                        <div style={{ fontWeight: 700, color: '#0f172a' }}>{m.total}</div>
                                                        <div style={{ color: '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{m.workflow}</div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Card>
            )}
        </>
    );
};

export default WipDashboardBranch;
